<template>
    <VueFinalModal class="modal" content-class="modal-content" overlay-transition="vfm-fade" :clickToClose="false"
        @click-outside="beforeClose">
        <div>
            <span class="title" v-if="props.value.id">Edit division</span>
            <span class="title" v-else>Create division</span>
            <div class="d-row">
                <div>
                    <label for="r_name">Name</label>
                    <input type="string" id="r_name" v-model="props.value.name" />
                </div>
            </div>
        </div>
        <div class="buttons">
            <button @click="beforeClose">Cancel</button>
            <button class="accent" @click="edit" v-if="props.value.id">Save changes</button>
            <button class="accent" @click="create" v-else>Create division</button>
        </div>
        <ConfirmModal :modal-id="confirmModalId" text="You have unsaved changes, do you really want to leave this form?"
            confirm-text="Close form" @confirm="() => {
                vfm.close(confirmModalId);
                emit('close');
            }
                " @close="vfm.close(confirmModalId)">
        </ConfirmModal>
    </VueFinalModal>
</template>

<script setup lang="ts">
import { DivisionItem } from "@/services/entities/DivisionItem";
import { useVfm, VueFinalModal } from "vue-final-modal";
import ConfirmModal from "./ConfirmModal.vue";

const vfm = useVfm();
const confirmModalId = Symbol("confirmModalId");
const emit = defineEmits(["create", "close", "edit"]);

function beforeClose() {
    vfm.open(confirmModalId);
}

const props = defineProps({
    value: { Type: {} as DivisionItem, default: {} as DivisionItem },
});

function create() {
    emit("create");
}

function edit() {
    emit("edit");
}
</script>

<style scoped lang="scss">
.title {
    font-size: 16px;
}
</style>